import experimentName from '@data/schemas/experimentName'
import experimentSegment from '@data/schemas/experimentSegment'
import getEmbeddedSelfArray from '@data/schemas/util/getEmbeddedSelfArray'
import { ObjectSchema, object } from 'yup'

export const isExperimentMap = (data: unknown): data is TExperimentMap => {
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return false
    }

    // Check for invalid properties, which should be experiment names
    if (Object.keys(data).some((name) => !experimentName.isValidSync(name))) {
        return false
    }

    // Check for invalid values, which should be segments
    if (Object.values(data).some((segment) => !experimentSegment.isValidSync(segment))) {
        return false
    }

    return true
}

function isStringTuple(x: unknown): x is [string, string] {
    return x != null && Array.isArray(x) && typeof x.at(0) === 'string' && typeof x.at(1) === 'string'
}

const schema: ObjectSchema<TExperimentMap, TExperimentMap> = object<TExperimentMap>()
    .transform((value) => {
        const experiments = getEmbeddedSelfArray(value)

        if (experiments === null) {
            return value
        }

        const mapped: Array<[string, string]> = experiments
            .map((experiment: unknown) => {
                if (
                    typeof experiment !== 'object' ||
                    !experiment ||
                    Array.isArray(experiment) ||
                    !('experimentName' in experiment) ||
                    !('segment' in experiment)
                ) {
                    return null
                }

                return [experiment.experimentName, experiment.segment]
            })
            .filter(isStringTuple)

        return Object.fromEntries(mapped)
    })
    .test('Is an experiment map', isExperimentMap)

export default schema
